import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { usePermissions } from '@shared/hooks/usePermissions';

/**
 * Botón para crear una nueva billetera.
 * Maneja la navegación y valida permisos antes de renderizarse.
 */
export const CreateWalletButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('walletsModule');
  const { canAccess } = usePermissions();

  // Validar permisos de creación
  const canCreate = canAccess(['tenant', 'tenant_external'], ['wallets.create']);

  if (!canCreate) {
    return null;
  }

  return (
    <Button variant="primary" size="lg" onClick={() => navigate('/wallets/create')} data-testid="create-wallet-button">
      {t('buttons.create')}
    </Button>
  );
};
